module.exports = __webpack_public_path__ + "img/meeycrm.bfeea77f.svg";